export default __webpack_public_path__ + "static/media/file-icon-xls.9e0fe600.svg";